import * as React from "react";

export interface SwapLabelsItemProps {
    recordId: string;
    isDisabled: boolean;
    onClick: () => void;
    correctionSelected: boolean;
}

export const SwapLabelsItem = ({ recordId, isDisabled, onClick, correctionSelected }: SwapLabelsItemProps): JSX.Element => {
    return (
        <li
            className="col-md-6"
            style={{ paddingLeft: 5 + "px", paddingRight: 5 + "px" }}
            onClick={isDisabled ? null : onClick}>
            <input type="radio" name={`EntityLabel${recordId}`} value="true" checked={correctionSelected} readOnly disabled={isDisabled} />
            <label>
                <span className="posh-select-icon"><i className="fa fa-edit" aria-hidden="true"></i></span>
                <span className="posh-select-body">
                    <span className="posh-select-title">Swap Session Labels</span>
                    <span className="posh-select-description text-muted">Swap the session labels with an already existing session</span>
                </span>
            </label>
        </li>
    );
}
